import React from 'react';
import Avatar from 'antd/lib/avatar';
import 'antd/lib/avatar/style/css';
import 'antd/lib/icon/style/css';

const getAvatar = (user, styles = {}) => {
  if (user && user.profile && user.profile.image) {
    return <Avatar size="large" shape="square" src={user.profile.image} />;
  }

  if (user && user.profile && user.profile.lastName) {
    return <Avatar size="large" shape="square" icon="user" />;
  }
};

export default getAvatar;



// WEBPACK FOOTER //
// ./src/lib/helpers/GeneralHelpers/getAvatar.js